import { createScreenStyles } from '../../theme/styles';
import React, { useState, useEffect } from 'react';
import { ActivityIndicator,View,StyleSheet,ScrollView, Dimensions, Text, TouchableHighlight } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

// import { Container } from './styles';

const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

  export default function checklist({ route, navigation }) {

    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");

    async function handleLogout(){
      await AsyncStorage.clear();
      navigation.navigate("Login");
    };

    async function getStorageValue() {
      setNome(await AsyncStorage.getItem('sfusernome'));
      setEmail(await AsyncStorage.getItem('sfuseremail'));
    }

    useEffect(() => {
      setLoading(true);
      getStorageValue();
      setLoading(false);
    }, []);

  return (
    <View style={styles.container}>
      {loading && (
            <ActivityIndicator size="large" style={styles.LoadingIndicator} />
          ) 
      }
      <ScrollView>

        <View style={styles.headerContainer}>        
          <Text numberOfLines={1} style={styles.textDescBold2}>Informações do Usuário</Text>
          <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>Nome: </Text>{nome}</Text>
          <Text numberOfLines={1} style={styles.textDesc}><Text style={styles.textDescBold}>E-mail: </Text>{email}</Text>
          <TouchableHighlight style={styles.btnEntrar} onPress={handleLogout}>
            <Text style={styles.textoEntrar}>SAIR</Text>
          </TouchableHighlight>
        </View>
            
      <View>
      <Text></Text>
      <Text></Text>
      </View>
    

      </ScrollView>
    </View>

   
  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#d5d5d5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  textDescPend: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#fa9200'
  },

  textDescOk: {
    fontSize: 14,
    paddingTop:5,
    fontWeight:'bold',
    color:'#4ead31'
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBold2: {
    fontSize: 14,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center'
  },

  headerContainer:{
    backgroundColor:'#fff',
    marginTop:5,
    marginLeft:5,
    marginRight:5,
    padding:10
  },

  textDescBold3: {
    fontSize: 15,
    marginBottom:5,
    fontWeight: "bold",
    textAlign:'center',
    color:'#484848'
  },

  btnEntrar:{
   width: "auto",
    backgroundColor:'#003c84',
    marginTop: 20,
    padding:15,
    borderRadius:5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.30,
    shadowRadius: 2.45,
    elevation: 5,
  },

  textoEntrar:{
    color:'#fff',
    textAlign:'center',
    fontSize:18,
  },
})


